import IconChevronDown16 from '@warp-ds/icons/react/chevron-down-16';
import cn from 'classnames';
import type { ReactNode } from 'react';

import styles from './TriggerButton.module.css';

export interface TriggerProps {
    triggerLabel?: string;
    text: string;
    prefix?: ReactNode;
    onTrigger: () => void;
    open?: boolean;
    slim?: boolean;
    aria?: {
        label?: string;
        hasPopup: 'listbox' | 'dialog';
    };
    hideChevron?: boolean;
    error?: string;
    hideLabelOnSmallScreen?: boolean;
}

export const TriggerButton = ({
    triggerLabel,
    text,
    aria,
    prefix,
    onTrigger,
    slim = false,
    open,
    hideChevron = false,
    error,
    hideLabelOnSmallScreen = false,
}: TriggerProps) => {
    return (
        <div
            className={cn(styles.wrapper, {
                [styles['wrapper--slim']]: slim,
            })}>
            {triggerLabel && (
                <strong
                    className={cn(styles['trigger-label'], {
                        [styles['trigger-label--hide-on-small']]: hideLabelOnSmallScreen,
                    })}>
                    {triggerLabel}
                </strong>
            )}
            <button
                type="button"
                onClick={onTrigger}
                className={cn(styles.trigger, {
                    [styles['trigger--slim']]: slim,
                    [styles['trigger--dialog']]: aria?.hasPopup === 'dialog',
                    [styles['trigger--error']]: error,
                })}
                {...(aria?.hasPopup ? { 'aria-haspopup': aria.hasPopup } : {})}
                {...(typeof open === 'boolean' ? { 'aria-expanded': open } : {})}
                {...(aria?.label ? { 'aria-label': aria.label } : {})}>
                <span className={styles.trigger__text}>
                    {prefix && <span className={styles.prefix}>{prefix}</span>}
                    {text && <span className={styles.text}>{text}</span>}
                </span>
                <IconChevronDown16
                    aria-hidden
                    className={
                        hideChevron ? 'hidden' : aria?.hasPopup === 'listbox' && open ? styles['chevron--open'] : styles['chevron--closed']
                    }
                />
            </button>
            {error && <span className={styles.error}>{error}</span>}
        </div>
    );
};
